import React from 'react';
import { range } from 'lodash';
import { PaginationNav } from '../../../../../../../common/components/PaginationNav/PaginationNav';
import { Pagination } from '@mm/state/store-interfaces';
import SelectorWithArrow from '../../../../../../../common/components/SelectorWithArrow/SelectorWithArrow';

type Props = {
  pagination: Pagination;
  onChangePage: (page: number) => void;
  onChangePerPage: (perPage: number) => void;
  page: number;
  perPage: number;
};

const PER_PAGE_OPTIONS = [
  { id: 25, name: '25' },
  { id: 50, name: '50' },
  { id: 100, name: '100' },
];

export const PaginationActions = (props: Props) => {
  const { page, perPage, onChangePage, onChangePerPage, pagination } = props;
  const pages = range(1, pagination.totalPages + 1, 1);
  const selectedPage = Math.min(page, pagination.totalPages);
  return (
    <div className="campaign-queue-modal__pagination-actions">
      <div className="campaign-queue-modal__per-page-wrapper">
        <span className="campaign-queue-modal__select-per-page-label">
          View:
        </span>
        <div className="campaign-queue-modal__per-page-dropdown">
          <SelectorWithArrow
            selectedItem={{ id: perPage, name: perPage.toString() }}
            items={PER_PAGE_OPTIONS}
            onChange={value => onChangePerPage(+value)}
          />
        </div>
      </div>
      <div className="campaign-queue-modal__pagination-wrapper">
        <span className="campaign-queue-modal__select-page-label">Page:</span>
        <div className="campaign-queue-modal__page-dropdown">
          <SelectorWithArrow
            selectedItem={{ id: selectedPage, name: selectedPage.toString() }}
            items={pages.map(v => ({ id: v, name: v.toString() }))}
            onChange={value => onChangePage(+value)}
          />
        </div>
        <PaginationNav
          className="campaign-queue-modal__pagination"
          withEllipsis={true}
          pagination={pagination}
          onChangePage={onChangePage}
          rangeLength={3}
        />
      </div>
    </div>
  );
};
